<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <h1 style="margin-bottom: 10px;">Download List</h1>

        <div style="max-width: 700px;width:100%;margin: 15px auto 30px;text-align: left;">
            - This page gathers some music I write, arrange, and transcribe.
            After studying music theory, I’ve built the habit of using it in practical ways such as transcribing pieces
            when no score exists, arranging music for the ensembles I play in, and composing original cues for micro
            films.
            Here you can download full scores and individual parts for some of these pieces.
        </div>
        <!-- <p style="color: #000;margin-bottom: 30px;">※ Password: accumbens</p> -->
        <a v-for="item in list" :key="item.name" :href="item.link" download class="link" :onclick="(e) => donwlonad(e)">
            {{ item.name }}
        </a>
    </div>
</template>
<script>
export default {
    name: "composition",
    components: {
    },
    donwlonad(e) {
        e.preventDefault();
        console.log("download");
        window.location.reload();
    },
    data() {
        return {
            list: [
                { name: "A step you can't take back - Instrumental Violincello", link: "/downloads/composition/A step you can't take back_instrumenta_Violincello.pdf" },
                { name: "A step you can't take back - Complete Score", link: "/downloads/composition/A step you can't take back_instrumental_Complete score.pdf" },
                { name: "A step you can't take back - Piano", link: "/downloads/composition/A step you can't take back_instrumental_piano.pdf" },
                { name: "A step you can't take back - Vocal", link: "/downloads/composition/A step you can't take back_instrumental_vocal.pdf" },
                { name: "Director's Theme and Variations (Part)", link: "/downloads/composition/Director's theme and variations (part).pdf" },
                { name: "La fille aux cheveus de lin - String Trio Complete Score", link: "/downloads/composition/La fille aux cheveus de lin_String Trio_Complete score.pdf" },
                { name: "La fille aux cheveus de lin - String Trio Violin I", link: "/downloads/composition/La fille aux cheveus de lin_String Trio_violin I.pdf" },
                { name: "La fille aux cheveus de lin - String Trio Violin II", link: "/downloads/composition/La fille aux cheveus de lin_String Trio_violin II.pdf" },
                { name: "La fille aux cheveus de lin - String Trio Violin III", link: "/downloads/composition/La fille aux cheveus de lin_String Trio_violin III.pdf" },
                { name: "Letter of No Return - Violin", link: "/downloads/composition/Letter of no return_violin.pdf" },
            ]
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

.link {
    display: block;
    margin-bottom: 10px;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>
